import { setFindMyCar } from "./findMyCarSlice";

import { type Building, FIND_MY_CAR_LOCATION_ID, LatLng } from "@/libs/models";
import store from "../../app/store";
import { isValidFloorId } from "../cartography/actions";
import { safeLocalStorage } from "../utils/utils";
import { WebviewApi } from "./../webview_api/index";
import { FindMyCarStatusTypes } from "./types";

export const isFindMyCarInBuilding = (buildingId: number) => {
  const findMyCar = store.getState().findMyCar;

  if (findMyCar.status !== FindMyCarStatusTypes.SAVED) return undefined;

  const building = store.getState().cartography.buildings[buildingId]
    .value as Building;

  return (
    building.getFloorById(findMyCar.floorId) &&
    building.isPointInsideBounds(
      new LatLng(findMyCar.coordinates.lat, findMyCar.coordinates.lng),
    )
  );
};

/**
 * It searches for a building that contains a find my car point whithin it.
 */
export const selectBuildingForFindMyCar = async () => {
  const cartographySlice = store.getState().cartography;
  const findMyCarEnabled =
    store.getState().config.feature_flags.find_my_car_active;
  const findMyCar = store.getState().findMyCar;

  if (!findMyCarEnabled || findMyCar.status !== FindMyCarStatusTypes.SAVED) {
    return null;
  }

  let building =
    cartographySlice.currentBuildingID === null
      ? undefined
      : cartographySlice.buildings[cartographySlice.currentBuildingID]?.value;
  // Check if there if fmc in current building
  building = isFindMyCarInBuilding(building.id) ? building : undefined;

  if (building) return building;

  // Check the rest of the buildings
  return Object.values(cartographySlice.buildings)
    .map((b) => b.value as Building)
    .find((b) => isFindMyCarInBuilding(b.id));
};

export const handleSaveFMC = ({
  coordinates,
  floorId,
}: {
  coordinates: { lat: number; lng: number };
  floorId: number;
}) => {
  if (!store.getState().config.feature_flags.find_my_car_active) {
    console.error("Error saving car: FMC feature not enabled");
    return;
  }
  if (
    typeof coordinates.lat !== "number" ||
    typeof coordinates.lng !== "number" ||
    !coordinates.lat ||
    !coordinates.lng
  ) {
    console.error("Error saving car: bad format on payload");
    return;
  }
  if (!isValidFloorId(floorId)) {
    console.error("Error saving car: invalid floor identifier");
    return;
  }

  store.dispatch(
    setFindMyCar({
      coordinates: coordinates,
      floorId: floorId,
      status: FindMyCarStatusTypes.SAVED,
    }),
  );
  safeLocalStorage.setItem("find-my-car", {
    coordinates: coordinates,
    floorId: floorId,
    status: FindMyCarStatusTypes.SAVED,
  });
  WebviewApi.onCarSaved({ coordinates, floorId });
};
